/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, forwardRef, Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Styles from './TableContents.module.scss';

// const TOP_OFFSET = 250;
let y;

const TableContents = forwardRef(({ list = [] }, ref) => {
  const [active, setActive] = useState();

  const observerTopCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setActive(entry.target.id);
      }
    });
  };

  const observerBottomCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const idx = list.findIndex((l) => l.target === entry.target.id);
        const previous = list[idx > 0 ? idx - 1 : idx];
        if (!previous?.target) return;
        setActive(previous.target);
      }
    });
  };

  useEffect(() => {
    if (!('IntersectionObserver' in window)) return;

    const observerTop = new IntersectionObserver(observerTopCallback, {
      rootMargin: '0% 0% -70%', // top 30% of viewport
      threshold: [1.0],
    });
    const observerBottom = new IntersectionObserver(observerBottomCallback, {
      rootMargin: '-30% 0% 0%', // bottom 70% of viewport
      threshold: [1.0],
    });

    const allHeadings = document.querySelectorAll('h2[id]');
    allHeadings.forEach((heading) => {
      observerTop.observe(heading);
      observerBottom.observe(heading);
    });

    return () => {
      observerTop.disconnect();
      observerBottom.disconnect();
    };
  }, [list]);

  return (
    <div ref={ref} className={Styles.container}>
      {list.length > 0 && (
        <Fragment>
          <div className={Styles.title}>{`Jump to Section`}</div>
          <ul className={Styles.list}>
            {list.map((l, idx) => (
              <li key={idx} className={Styles.item}>
                <a
                  href={`#${l.target}`}
                  className={classNames(Styles.link, active === l.target && Styles.active)}>
                  {l.title}
                </a>
              </li>
            ))}
          </ul>
        </Fragment>
      )}
    </div>
  );
});

TableContents.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      target: PropTypes.string,
    })
  ),
};

export default TableContents;
